import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {object} from 'prop-types'
import {useSelector} from 'react-redux'
// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27703340
export const vipConsumeRankType = createAsyncThunk(
  '/live/activity/vip_consume_rank_type',
  async (arg, store) => {
    const resp = await http.post<
      HiyaRes<{
        rank_type_array: InitialStateType['rank_type_array']
      }>
    >('/live/activity/vip_consume_rank_type', store.getState().env.deviceinfo)
    return resp.data.data
  }
)

export const vipConsumeRankList = createAsyncThunk(
  '/live/activity/vip_consume_rank_list',
  async (
    arg: {
      rank_type: number
      offset: number
      page_size: number
    },
    store
  ) => {
    const resp = await http.post<
      HiyaRes<Omit<InitialStateType, 'rank_type_array'>>
    >('/live/activity/vip_consume_rank_list', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  // 该地区有哪些用户排行榜单
  rank_type_array?: number[]
  remain_seconds?: number
  own?: any
  vip_rank_info_list?: []
  offset?: number
  more?: true
}

const initialState: InitialStateType = {}

export const NewBIgRSlice = createSlice({
  name: 'NewBIgR',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(vipConsumeRankType.fulfilled, (state, action) => {
      Object.assign(state, {
        rank_type_array: action.payload.rank_type_array,
      })
    })
    builder.addCase(vipConsumeRankList.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default NewBIgRSlice.reducer
export const useNewBIgRState = () => {
  const data = useSelector((state) => state.NewBIgR)
  return data
}
